import Image from "next/image"
import React from "react"

import AppDownload from "../svg/appDownload.svg"
import AppStore from "../svg/appStore.svg"
import GooglePlay from "../svg/googlePlay.svg"

interface DownloadLinkProps {
  deeplinkUrl?: string | null
}

const DownloadLink: React.FC<DownloadLinkProps> = ({ deeplinkUrl }) => {
  const userAgent = navigator.userAgent

  const isIOS = /iPad|iPhone|iPod/.test(userAgent)
  const isAndroid = /android/i.test(userAgent)

  const appStoreUrl = "https://apps.apple.com/mx/app/nelo/id1477987798"
  const playStoreUrl = "https://play.google.com/store/apps/details?id=co.nelo.nelo&amp;gl=MX"

  if (isIOS) {
    return (
      <div>
        <a href={deeplinkUrl || appStoreUrl}>
          <Image className="my-4 w-[180px]" src={AppStore} loading="lazy" alt="Download on the App Store" />
        </a>
      </div>
    )
  } else if (isAndroid) {
    return (
      <div>
        <a href={deeplinkUrl || playStoreUrl}>
          <Image className="my-4 w-[180px]" src={GooglePlay} loading="lazy" alt="Get it on Google Play" />
        </a>
      </div>
    )
  } else {
    return (
      <div className="text-center md:text-left">
        <Image src={AppDownload} className="mx-auto mt-6 rounded-[10px] md:mx-0" alt="QR Code" />
      </div>
    )
  }
}

export default DownloadLink
